import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { EditClientVm } from '../../shared/generated/Clients/Models/EditClientVm';
import { Title } from '@angular/platform-browser';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, ParamMap, Router, RouterModule } from '@angular/router';
import { NavigationService } from 'app/shared/navigation/navigation.service';
import { SharedModule } from 'app/shared/shared.module';
import { firstValueFrom } from 'rxjs';
import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { SelectItem } from 'app/shared/models/select-item';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'pcg-edit-client',
    templateUrl: './edit-client.component.html',
    styleUrls: ['./edit-client.component.css'],
    imports: [SharedModule, RouterModule]
})
export class EditClientComponent {
	formGroup = EditClientVm.Form;
	model: EditClientVm;
	id: number;
	letterCodes: Array<SelectItem> = [];
	@ViewChild('createLetterCode', { static: true }) modalContent: TemplateRef<any>;

	constructor(
		title: Title,
		public httpClient: HttpClient,
		public route: ActivatedRoute,
		public nav: NavigationService,
		public router: Router,
		public modalService: NgbModal,
		public systemMessage: SystemMessageService
	) {
		title.setTitle('Edit Client');
	}

	async ngOnInit(): Promise<void> {
		this.nav.setOpenSecondaryMenu(['Clients', 'Details']);
		this.route.paramMap.subscribe(async (paramMap: ParamMap) => {
			this.id = Number(paramMap.get('id'));
			this.model = await firstValueFrom(
				this.httpClient.get<EditClientVm>(`api/Clients/Client/GetViewModel/${this.id}`)
			);
			this.formGroup.patchValue(this.model);
			this.getLetterCodeList(this.id);
		});
	}

	openLetterCodeDetails = client => {
		const params = new HttpParams().set('name', client).set('clientId', this.id);
		this.httpClient
			.get<SystemMessage>(`api/Clients/Client/SaveNewLetterCodeTwoParams/`, { params })
			.subscribe(m => {
				var { message, messageClass } = m;
				this.getLetterCodeList(this.id);
				if (messageClass !== 'success') {
					this.systemMessage.setSystemMessage(message, messageClass);
				}
			});
	};

	getLetterCodeList(id: Number) {
		this.httpClient.get<SelectItem[]>(`api/Select/LetterCodes/${id}`).subscribe((items: SelectItem[]) => {
			this.letterCodes = items;
		});
	}

	saveClient(msg: SystemMessage) {
		if (!msg.isSuccessful) {
			return;
		}
		const model = this.formGroup.value;
		this.id = model.userId;
		if (msg.isSuccessful) {
			this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
				this.router.navigate([`clients`]);
			});
		}
	}
}
